/**
 * Description : Composant client qui encapsule l'application avec les providers d'authentification et de projet
 * Utilisé dans : app/layout.tsx
 */
'use client'
import { PendingMoyensProvider } from '@/contexts/PendingMoyensContext'
import { ProjectProvider } from '@/contexts/ProjectContext'
import { SessionProvider } from "next-auth/react"

/**
 * Layout client qui configure les providers d'authentification et de contexte de projet
 * Gère la navigation et la structure de base de l'interface utilisateur
 */
export default function RootLayoutClient({
  children,
}: {
  children: React.ReactNode
}) {
  return (
     <SessionProvider>
        <ProjectProvider>
           <PendingMoyensProvider>
              <div className="min-h-screen bg-gray-50">
                {children}
              </div>
           </PendingMoyensProvider>
        </ProjectProvider>
      </SessionProvider>
  )
}